import { Component, OnInit } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { AnalyticsService, HeaderApplicationsService } from '@uefa-shared/frontend'
import { ApplicationSearchDTO } from '@uefa-vista/contracts'
import { debounceTime, filter } from 'rxjs/operators'
import { environment } from '../environments/environment'
import { ApplicationsService } from './shared/services/api'

@Component({
  selector: 'svr-root',
  template: `<router-outlet></router-outlet>`,
})
export class AppComponent implements OnInit {
  constructor(
    private readonly translateService: TranslateService,
    private readonly applicationService: ApplicationsService,
    private readonly headerApplicationService: HeaderApplicationsService,
    private readonly analyticsService: AnalyticsService,
    private readonly router: Router
  ) {
    // Initialize GA first
    AnalyticsService.initializeGA(environment)
  }

  public ngOnInit(): void {
    // Then initialize other services
    this.translateService.addLangs(['en'])
    this.translateService.setDefaultLang('en')

    const searchDTO = new ApplicationSearchDTO()
    searchDTO.inApplicationMenu = true

    this.applicationService.getAll(searchDTO).subscribe((apps) => {
      this.headerApplicationService.setApplications(apps.filter((app) => app.name !== environment.name))
    })

    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        debounceTime(500)
      )
      .subscribe(() => {
        this.analyticsService.logEvent({ name: 'svr_page_view', params: {} })
      })
  }
}
